import { rdsPostgresMcp } from "@p0security/integrations-aws-rds-shared/mcp/rds-postgres";
import { awsMcp } from "@p0security/integrations-aws-shared/mcp";
import {
  cloudflareAiMcpServerAvailability,
  cloudflareAiMcpServers,
} from "@p0security/integrations-cloudflare-ai-shared/mcp";
import {
  databricksAiMcpServerAvailability,
  databricksAiMcpServers,
} from "@p0security/integrations-databricks-ai-shared/mcp";
import {
  datadogAiMcpServerAvailability,
  datadogAiMcpServers,
} from "@p0security/integrations-datadog-ai-shared/mcp";
import {
  dynamoDbAiMcpServerAvailability,
  dynamoDbAiMcpServers,
} from "@p0security/integrations-dynamodb-ai-shared/mcp";
import {
  gcpBigQueryMcp,
  gcpComputeMcp,
  gcpFirestoreMcp,
  gcpIamMcp,
  gcpLoggingMcp,
  gcpMonitoringMcp,
  gcpStorageMcp,
} from "@p0security/integrations-gcloud-shared/mcp/servers";
import { githubAiMcp } from "@p0security/integrations-github-ai-shared/mcp";
import {
  gitlabAiMcpServerAvailability,
  gitlabAiMcpServers,
} from "@p0security/integrations-gitlab-ai-shared/mcp";
import {
  googleDriveAiMcp,
  googleDriveAiMcpServerAvailability,
} from "@p0security/integrations-google-drive-ai-shared/mcp";
import {
  jiraAiMcpResolver,
  jiraAiMcpServerAvailability,
} from "@p0security/integrations-jira-ai-shared/mcp";
import {
  lookerAiMcp,
  lookerAiMcpServerAvailability,
} from "@p0security/integrations-looker-ai-shared/mcp";
import {
  miroAiMcpResolver,
  miroAiMcpServerAvailability,
} from "@p0security/integrations-miro-ai-shared/mcp";
import {
  mongodbAtlasAiMcp,
  mongodbAtlasAiMcpServerAvailability,
} from "@p0security/integrations-mongodb-atlas-ai-shared/mcp";
import {
  pagerdutyAiMcpServerAvailability,
  pagerdutyAiMcpServers,
} from "@p0security/integrations-pagerduty-ai-shared/mcp";
import { redshiftAiMcpServerFamily } from "@p0security/integrations-redshift-ai-shared/mcp";
import {
  salesforceAiMcp,
  salesforceAiMcpServerAvailability,
} from "@p0security/integrations-salesforce-ai-shared/mcp";
import {
  serviceNowAiMcp,
  serviceNowAiMcpServerAvailability,
} from "@p0security/integrations-servicenow-ai-shared/mcp";
import { snowflakeAiMcpServerFamily } from "@p0security/integrations-snowflake-ai-shared/mcp";
import {
  tableauAiMcp,
  tableauAiMcpServerAvailability,
} from "@p0security/integrations-tableau-ai-shared/mcp";
import type { NewConfig } from "@p0security/shared/integrations/shared";
import type { McpServerSpec } from "@p0security/shared/types/agentic/mcp";

import { aieraMcpResolver } from "./saas/aiera.ts";
import { airopsMcpResolver } from "./saas/airops.ts";
import { airtableMcpResolver } from "./saas/airtable.ts";
import { amplitudeMcpResolver } from "./saas/amplitude.ts";
import { atlassianMcpResolver } from "./saas/atlassian.ts";
import { attioMcpResolver } from "./saas/attio.ts";
import { audioscrapeMcpResolver } from "./saas/audioscrape.ts";
import { bitlyMcpResolver } from "./saas/bitly.ts";
import { buildkiteMcpResolver } from "./saas/buildkite.ts";
import { calendlyMcpResolver } from "./saas/calendly.ts";
import { canvaMcpResolver } from "./saas/canva.ts";
import { carbonVoiceMcpResolver } from "./saas/carbon-voice.ts";
import { cdataConnectAiMcpResolver } from "./saas/cdata-connect-ai.ts";
import { circlebackMcpResolver } from "./saas/circleback.ts";
import { clarifyMcpResolver } from "./saas/clarify.ts";
import { closeMcpResolver } from "./saas/close.ts";
import { cloudflareDeveloperPlatformMcpResolver } from "./saas/cloudflare-developer-platform.ts";
import { cloudflareObservabilityMcpResolver } from "./saas/cloudflare-observability.ts";
import { cloudinaryMcpResolver } from "./saas/cloudinary.ts";
import { couplerMcpResolver } from "./saas/coupler.ts";
import { daloopaMcpResolver } from "./saas/daloopa.ts";
import { dialerMcpResolver } from "./saas/dialer.ts";
import { eanSearchMcpResolver } from "./saas/ean-search.ts";
import { fathomMcpResolver } from "./saas/fathom.ts";
import { fellowMcpResolver } from "./saas/fellow.ts";
import { firefliesMcpResolver } from "./saas/fireflies.ts";
import { globalpingMcpResolver } from "./saas/globalping.ts";
import { granolaMcpResolver } from "./saas/granola.ts";
import { honeycombMcpResolver } from "./saas/honeycomb.ts";
import { huggingFaceMcpResolver } from "./saas/hugging-face.ts";
import { instantMcpResolver } from "./saas/instant.ts";
import { invideoMcpResolver } from "./saas/invideo.ts";
import { jamMcpResolver } from "./saas/jam.ts";
import { klaviyoMcpResolver } from "./saas/klaviyo.ts";
import { launchDarklyMcpResolver } from "./saas/launchdarkly.ts";
import { linearMcpResolver } from "./saas/linear.ts";
import { listeneticMcpResolver } from "./saas/listenetic.ts";
import { luminMcpResolver } from "./saas/lumin.ts";
import { mercuryMcpResolver } from "./saas/mercury.ts";
import { metaAdsPipeboardMcpResolver } from "./saas/meta-ads-pipeboard.ts";
import { miroMcpResolver } from "./saas/miro.ts";
import { mondayMcpResolver } from "./saas/monday.ts";
import { morningstarMcpResolver } from "./saas/morningstar.ts";
import { motherduckMcpResolver } from "./saas/motherduck.ts";
import { mypromindMcpResolver } from "./saas/mypromind.ts";
import { neonMcpResolver } from "./saas/neon.ts";
import { netlifyMcpResolver } from "./saas/netlify.ts";
import { notionMcpResolver } from "./saas/notion.ts";
import { octagonMcpResolver } from "./saas/octagon.ts";
import { otterMcpResolver } from "./saas/otter.ts";
import { parallelSearchMcpResolver } from "./saas/parallel-search.ts";
import { parallelTaskMcpResolver } from "./saas/parallel-task.ts";
import { paypalMcpResolver } from "./saas/paypal.ts";
import { plaidMcpResolver } from "./saas/plaid.ts";
import { portMcpResolver } from "./saas/port.ts";
import { prismaPostgresMcpResolver } from "./saas/prisma-postgres.ts";
import { rampMcpResolver } from "./saas/ramp.ts";
import { readAiMcpResolver } from "./saas/read-ai.ts";
import { sentryMcpResolver } from "./saas/sentry.ts";
import { simplescraperMcpResolver } from "./saas/simplescraper.ts";
import { stripeMcpResolver } from "./saas/stripe.ts";
import { stytchMcpResolver } from "./saas/stytch.ts";
import { supabaseMcpResolver } from "./saas/supabase.ts";
import { supermetricsMcpResolver } from "./saas/supermetrics.ts";
import { synapseMcpResolver } from "./saas/synapse.ts";
import { thoughtspotMcpResolver } from "./saas/thoughtspot.ts";
import { tldvMcpResolver } from "./saas/tldv.ts";
import { todoistMcpResolver } from "./saas/todoist.ts";
import { udemyBusinessMcpResolver } from "./saas/udemy-business.ts";
import { webflowMcpResolver } from "./saas/webflow.ts";
import { windsorMcpResolver } from "./saas/windsor.ts";
import { wixMcpResolver } from "./saas/wix.ts";
import { wordpressMcpResolver } from "./saas/wordpress.ts";
import { zenableMcpResolver } from "./saas/zenable.ts";
import { zineMcpResolver } from "./saas/zine.ts";
import type { McpServerSpecResolver } from "./types.ts";

export const mcpServers: Record<string, McpServerSpec | McpServerSpecResolver> =
  {
    aiera: aieraMcpResolver,
    airops: airopsMcpResolver,
    airtable: airtableMcpResolver,
    amplitude: amplitudeMcpResolver,
    atlassian: atlassianMcpResolver,
    attio: attioMcpResolver,
    audioscrape: audioscrapeMcpResolver,
    aws: awsMcp,
    bitly: bitlyMcpResolver,
    buildkite: buildkiteMcpResolver,
    calendly: calendlyMcpResolver,
    canva: canvaMcpResolver,
    carbonVoice: carbonVoiceMcpResolver,
    cdataConnectAi: cdataConnectAiMcpResolver,
    circleback: circlebackMcpResolver,
    clarify: clarifyMcpResolver,
    close: closeMcpResolver,
    cloudflareDeveloperPlatform: cloudflareDeveloperPlatformMcpResolver,
    cloudflareObservability: cloudflareObservabilityMcpResolver,
    ...cloudflareAiMcpServers,
    cloudinary: cloudinaryMcpResolver,
    coupler: couplerMcpResolver,
    daloopa: daloopaMcpResolver,
    ...databricksAiMcpServers,
    ...datadogAiMcpServers,
    ...dynamoDbAiMcpServers,
    dialer: dialerMcpResolver,
    eanSearch: eanSearchMcpResolver,
    fathom: fathomMcpResolver,
    fellow: fellowMcpResolver,
    fireflies: firefliesMcpResolver,
    gcpBigQuery: gcpBigQueryMcp,
    gcpCompute: gcpComputeMcp,
    gcpFirestore: gcpFirestoreMcp,
    gcpIam: gcpIamMcp,
    gcpLogging: gcpLoggingMcp,
    gcpMonitoring: gcpMonitoringMcp,
    gcpStorage: gcpStorageMcp,
    github: githubAiMcp,
    ...gitlabAiMcpServers,
    globalping: globalpingMcpResolver,
    // Not `googleDriveAi`: the key is stored as each added server's
    // `definition.id`, so it stays fixed when the integration is renamed.
    googleDrive: googleDriveAiMcp,
    granola: granolaMcpResolver,
    honeycomb: honeycombMcpResolver,
    huggingFace: huggingFaceMcpResolver,
    instant: instantMcpResolver,
    invideo: invideoMcpResolver,
    jam: jamMcpResolver,
    // Not `jiraAi`: the key is stored as each added server's `definition.id`,
    // so it never changes. Distinct from `atlassian`, the OAuth server at the
    // same URL.
    jiraAgentPool: jiraAiMcpResolver,
    klaviyo: klaviyoMcpResolver,
    launchdarkly: launchDarklyMcpResolver,
    linear: linearMcpResolver,
    listenetic: listeneticMcpResolver,
    looker: lookerAiMcp,
    lumin: luminMcpResolver,
    mercury: mercuryMcpResolver,
    metaAdsPipeboard: metaAdsPipeboardMcpResolver,
    miro: miroMcpResolver,
    // Not `miroAi`: the key is stored as each added server's `definition.id`,
    // so it never changes. Distinct from `miro`, the OAuth server at the same
    // URL, which takes requests by tool name.
    miroBoard: miroAiMcpResolver,
    monday: mondayMcpResolver,
    mongodbAtlas: mongodbAtlasAiMcp,
    morningstar: morningstarMcpResolver,
    motherduck: motherduckMcpResolver,
    mypromind: mypromindMcpResolver,
    neon: neonMcpResolver,
    netlify: netlifyMcpResolver,
    notion: notionMcpResolver,
    octagon: octagonMcpResolver,
    otter: otterMcpResolver,
    parallelSearch: parallelSearchMcpResolver,
    parallelTask: parallelTaskMcpResolver,
    plaid: plaidMcpResolver,
    prismaPostgres: prismaPostgresMcpResolver,
    rdsPostgres: rdsPostgresMcp,
    ...pagerdutyAiMcpServers,
    paypal: paypalMcpResolver,
    port: portMcpResolver,
    ramp: rampMcpResolver,
    readAi: readAiMcpResolver,
    salesforce: salesforceAiMcp,
    sentry: sentryMcpResolver,
    servicenow: serviceNowAiMcp,
    simplescraper: simplescraperMcpResolver,
    stripe: stripeMcpResolver,
    stytch: stytchMcpResolver,
    supabase: supabaseMcpResolver,
    supermetrics: supermetricsMcpResolver,
    synapse: synapseMcpResolver,
    tableau: tableauAiMcp,
    thoughtspot: thoughtspotMcpResolver,
    tldv: tldvMcpResolver,
    todoist: todoistMcpResolver,
    udemyBusiness: udemyBusinessMcpResolver,
    webflow: webflowMcpResolver,
    windsor: windsorMcpResolver,
    wix: wixMcpResolver,
    wordpress: wordpressMcpResolver,
    zenable: zenableMcpResolver,
    zine: zineMcpResolver,
  } as const;

/** Whether a predefined server can be added, given the tenant's installed
 * integrations. A server without an entry can always be added. */
export const mcpServerAvailability: Record<
  string,
  (installed: Record<string, NewConfig>) => boolean
> = {
  ...cloudflareAiMcpServerAvailability,
  ...databricksAiMcpServerAvailability,
  ...datadogAiMcpServerAvailability,
  ...dynamoDbAiMcpServerAvailability,
  ...gitlabAiMcpServerAvailability,
  ...googleDriveAiMcpServerAvailability,
  ...jiraAiMcpServerAvailability,
  ...lookerAiMcpServerAvailability,
  ...miroAiMcpServerAvailability,
  ...mongodbAtlasAiMcpServerAvailability,
  ...pagerdutyAiMcpServerAvailability,
  ...salesforceAiMcpServerAvailability,
  ...serviceNowAiMcpServerAvailability,
  ...tableauAiMcpServerAvailability,
};

/** A catalog entry that offers one server per installed item of an
 * integration, rather than one server. A server added from it is stored with
 * `definition.id` = `<family>:<item id>` (see {@link familyServerId}), and
 * its spec is rebuilt from that id wherever the catalog is read.
 *
 * Opt-in: an integration whose server depends on its item (e.g. a URL per
 * account) registers here. Every {@link mcpServers} entry is unaffected.
 */
export type McpServerFamily = {
  /** The item ids that can each name a server, given the tenant's installed
   * integrations. An empty list offers none. */
  items: (installed: Record<string, NewConfig>) => string[];
  /** The server for one item id, or undefined for an id that can't name one.
   * The id comes from stored config, so this must validate it. */
  spec: (item: string) => McpServerSpec | McpServerSpecResolver | undefined;
};

export const mcpServerFamilies: Record<string, McpServerFamily> = {
  // Not `snowflakeAi`: the key is stored in each added server's
  // `definition.id`, so it stays fixed if the integration is renamed.
  // Not `redshiftAi`, for the same reason.
  redshift: redshiftAiMcpServerFamily,
  snowflake: snowflakeAiMcpServerFamily,
};

/** Never in an {@link mcpServers} key, so a family id can't shadow one. */
const FAMILY_SEPARATOR = ":";

/** The stored `definition.id` of one family's server for one item. */
export const familyServerId = (family: string, item: string) =>
  `${family}${FAMILY_SEPARATOR}${item}`;

/** The catalog entry a stored `definition.id` names: an {@link mcpServers}
 * entry, or else a family's server for one item. Undefined for an id that
 * names neither, and for no id: the install form checks a p0 definition
 * before a server is picked. */
export const predefinedMcpServer = (
  id: string | undefined
): McpServerSpec | McpServerSpecResolver | undefined => {
  if (typeof id !== "string") return undefined;
  if (Object.getOwnPropertyDescriptor(mcpServers, id)) return mcpServers[id];
  const at = id.indexOf(FAMILY_SEPARATOR);
  if (at < 0) return undefined;
  const family = id.slice(0, at);
  if (!Object.getOwnPropertyDescriptor(mcpServerFamilies, family))
    return undefined;
  return mcpServerFamilies[family].spec(id.slice(at + 1));
};
